<template>
  <span class="svg-icon-reward-to-receive">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6538_6764)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M23 13C23 19.0751 18.0751 24 12 24C5.92487 24 1 19.0751 1 13C1 6.92487 5.92487 2 12 2C18.0751 2 23 6.92487 23 13ZM21 13C21 8.02944 16.9706 4 12 4C9.87499 4 7.92199 4.73647 6.38231 5.9681L19.0319 18.6177C20.2635 17.078 21 15.125 21 13ZM17.6177 20.0319L4.9681 7.38231C3.73647 8.92199 3 10.875 3 13C3 17.9706 7.02944 22 12 22C14.125 22 16.078 21.2635 17.6177 20.0319Z" :fill="color"/>
    </g>
    <defs>
    <clipPath id="clip0_6538_6764">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
    </defs>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default: '#00B33C' },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
